import _regeneratorRuntime from "/app/node_modules/babel-runtime/regenerator";
import _asyncToGenerator from "/app/node_modules/babel-runtime/helpers/asyncToGenerator";
import _classCallCheck from "/app/node_modules/babel-runtime/helpers/classCallCheck";
import _createClass from "/app/node_modules/babel-runtime/helpers/createClass";
export var MailApi = function () {
  function MailApi(axios) {
    _classCallCheck(this, MailApi);

    this.axios = axios;
  }

  _createClass(MailApi, [{
    key: "sendAffiliationCompletedMail",
    value: function sendAffiliationCompletedMail(data) {
      return this.axios.$post("/mailing/mailing/affiliation-completed", data);
    }
  }, {
    key: "sendSuccesfullyCreatedUserMail",
    value: function sendSuccesfullyCreatedUserMail(data) {
      return this.axios.$post("/mailing/mailing/successfully-created-user", data);
    }
  }, {
    key: "sendSummaryMail",
    value: function sendSummaryMail(data) {
      return this.axios.$post("/mail/mailing/summaryV2", data);
    }
  }, {
    key: "sendReqExcelAffiliation",
    value: function sendReqExcelAffiliation(data) {
      return this.axios.$post("/mail/mailing/send-attach-req-excel-affiliation", data);
    }
  }, {
    key: "sendSummaryMailErrors",
    value: function sendSummaryMailErrors(data) {
      // console.log('Viendo la data de los correos gaaaaa: ', data)
      return this.axios.$post("/mail/mailing/summaryV3", data);
    }
  }, {
    key: "sendRestorePasswordMail",
    value: function sendRestorePasswordMail(data) {
      return this.axios.$post("/mailing/mailing/restore-password", data);
    }
  }, {
    key: "verifiedEmail",
    value: function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(data) {
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return this.axios.$post("/mail/sap/validar-correo", data);

              case 2:
                return _context.abrupt("return", _context.sent);

              case 3:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function verifiedEmail(_x) {
        return _ref.apply(this, arguments);
      }

      return verifiedEmail;
    }()
  }]);

  return MailApi;
}();


//////////////////
// WEBPACK FOOTER
// ./src/api/mail.js
// module id = ./src/api/mail.js
// module chunks = 34